import { Box, IconButton, Popover, Tooltip } from '@mui/material';
import HeaderSearch from './Search';
import HeaderNotifications from './Notifications';
import Toggle from './ThemeToggle';
import { useState, useEffect, useRef } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';

function HeaderButtons() {
  const [themeName, setThemeName] = useState('PureLightTheme');
  const moreAnchorRef = useRef<HTMLButtonElement | null>(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const onStorage = () => {
      setThemeName(localStorage.getItem('appTheme') || 'PureLightTheme');
    };
    window.addEventListener('storage', onStorage);
    setThemeName(localStorage.getItem('appTheme') || 'PureLightTheme');
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const handleThemeChange = (newTheme: string) => {
    setThemeName(newTheme);
    localStorage.setItem('appTheme', newTheme);
    window.dispatchEvent(new Event('storage'));
  };

  return (
    <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
      {/* Desktop / Tablet (md+): show search, notifications, theme toggle inline (no redundant More button) */}
      <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
        <HeaderSearch />
        <Box sx={{ mx: 0.5 }} component="span">
          <HeaderNotifications />
        </Box>
        <Toggle currentTheme={themeName} onThemeChange={handleThemeChange} />
      </Box>

      {/* Mobile (xs-sm) - collapse actions to a More menu */}
      <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center' }}>
        <Tooltip title="Menu actions">
          <IconButton
            color="primary"
            ref={moreAnchorRef}
            onClick={() => setMobileOpen(true)}
            aria-label="open actions"
            aria-haspopup="true"
            aria-expanded={mobileOpen ? 'true' : undefined}
            sx={{ width: 44, height: 44 }}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
        <Popover
          open={mobileOpen}
          anchorEl={moreAnchorRef.current}
          onClose={() => setMobileOpen(false)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{ sx: { p: 0.5, display: 'flex', alignItems: 'center' } }}
          disableScrollLock
        >
          <HeaderSearch />
          <Box sx={{ mx: 0.25 }} component="span">
            <HeaderNotifications />
          </Box>
          <Toggle currentTheme={themeName} onThemeChange={handleThemeChange} />
        </Popover>
      </Box>
    </Box>
  );
}

export default HeaderButtons;
